import {useParams} from 'react-router-dom';

import {useCoreweaveIdQuery} from '../../generated/graphql';
import {useIsInLoadedReportContext} from '../../pages/ReportPage/LoadedReportContext';
import {useRampFlagIssuesObservability} from '../../util/rampFeatureFlags';

export const useRampFlagCoreweaveIssues = () => {
  const {entityName} = useParams<{
    entityName: string;
  }>();
  const ramp = useRampFlagIssuesObservability(entityName);

  // currently there is no support for issues in a report, so this check is used
  // to block the column from showing up outside a workspace
  const isInReport = useIsInLoadedReportContext();
  const {data} = useCoreweaveIdQuery({
    variables: {entity: entityName},
  });
  const coreweaveId = data?.entity?.organization?.coreWeaveOrganizationId;
  return ramp && !!coreweaveId && !isInReport;
};
